const MEDIA_ITEMS = [
  {
    id: 1,
    title: '热门电影精选',
    desc: '2025最新上映大片合集，动作科幻喜剧一网打尽',
    tag: '电影',
    views: '128.5万',
    rating: '9.2',
    img: 'https://readdy.ai/api/search-image?query=Cinematic%20film%20scene%20collage%20in%20warm%20amber%20and%20deep%20red%20tones%2C%20abstract%20movie%20poster%20style%2C%20dramatic%20lighting%2C%20movie%20genre%20atmosphere%2C%20dark%20elegant%20background%2C%20no%20text%2C%20professional%20cinematography&width=640&height=360&seq=media-card-01&orientation=landscape',
  },
  {
    id: 2,
    title: '高分剧集推荐',
    desc: '豆瓣8.5+精选好剧，悬疑爱情古装全覆盖',
    tag: '电视剧',
    views: '96.3万',
    rating: '9.0',
    img: 'https://readdy.ai/api/search-image?query=TV%20drama%20series%20abstract%20visual%20in%20warm%20golden%20and%20burgundy%20tones%2C%20dramatic%20mood%20lighting%2C%20cinematic%20aesthetic%2C%20dark%20rich%20background%2C%20no%20text%2C%20professional%20quality&width=640&height=360&seq=media-card-02&orientation=landscape',
  },
  {
    id: 3,
    title: '动漫新番速递',
    desc: '每周同步更新，热血治愈奇幻新番抢先看',
    tag: '动漫',
    views: '87.1万',
    rating: '8.8',
    img: 'https://readdy.ai/api/search-image?query=Anime%20style%20abstract%20composition%20with%20vibrant%20warm%20colors%2C%20crimson%20and%20golden%20accents%2C%20dynamic%20abstract%20shapes%2C%20dark%20atmospheric%20background%2C%20no%20text%2C%20modern%20illustration%20quality&width=640&height=360&seq=media-card-03&orientation=landscape',
  },
  {
    id: 4,
    title: '综艺爆笑合集',
    desc: '热门综艺欢乐不断，搞笑名场面一次看过瘾',
    tag: '综艺',
    views: '112.7万',
    rating: '8.9',
    img: 'https://readdy.ai/api/search-image?query=Entertainment%20variety%20show%20abstract%20visual%20with%20bright%20warm%20amber%20and%20coral%20gradients%2C%20energetic%20atmosphere%2C%20dark%20rich%20backdrop%2C%20no%20text%2C%20vibrant%20cinematic%20aesthetic&width=640&height=360&seq=media-card-04&orientation=landscape',
  },
  {
    id: 5,
    title: '纪录片精选',
    desc: '高分纪实大片，自然人文科技深度探索世界',
    tag: '纪录片',
    views: '63.4万',
    rating: '9.3',
    img: 'https://readdy.ai/api/search-image?query=Documentary%20film%20abstract%20visual%20with%20earthy%20warm%20terracotta%20and%20deep%20brown%20tones%2C%20natural%20exploration%20theme%2C%20dark%20elegant%20background%2C%20no%20text%2C%20sophisticated%20cinematography&width=640&height=360&seq=media-card-05&orientation=landscape',
  },
];

export default function MediaSection() {
  return (
    <section id="media" className="py-14 md:py-20 bg-background-50">
      <div className="max-w-6xl mx-auto px-4 md:px-6">
        <div className="flex items-end justify-between mb-8 md:mb-10">
          <div>
            <h2 className="text-2xl md:text-3xl font-bold text-foreground-950">热门视频</h2>
            <p className="text-sm text-foreground-500 mt-2">精选高分影视内容，即刻在线观看</p>
          </div>
          <a href="#index" className="hidden sm:flex items-center gap-1 text-sm text-primary-600 hover:text-primary-700 font-medium whitespace-nowrap">
            更多内容 <i className="ri-arrow-right-line"></i>
          </a>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-5 gap-4 md:gap-5">
          {MEDIA_ITEMS.map((item) => (
            <article
              key={item.id}
              className="group relative bg-background-50 border border-background-200/60 rounded-xl overflow-hidden hover:border-primary-300 transition-all duration-300 cursor-pointer"
            >
              <div className="relative aspect-video overflow-hidden bg-background-100">
                <img
                  src={item.img}
                  alt={item.title}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                  loading="lazy"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/60 to-transparent"></div>
                <div className="absolute bottom-2 right-2 bg-black/70 text-background-50 text-[10px] px-2 py-0.5 rounded">
                  {item.views}次播放
                </div>
                <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-12 h-12 flex items-center justify-center bg-primary-500/90 rounded-full opacity-0 group-hover:opacity-100 transition-opacity duration-300">
                  <i className="ri-play-fill text-background-50 text-xl leading-none"></i>
                </div>
              </div>
              <div className="p-3 md:p-4">
                <div className="flex items-center gap-2 mb-1.5">
                  <span className="text-[10px] px-1.5 py-0.5 bg-primary-100 text-primary-700 rounded font-medium">{item.tag}</span>
                  <span className="text-[10px] text-accent-600 font-semibold flex items-center gap-0.5">
                    <i className="ri-star-fill text-[10px]"></i>{item.rating}
                  </span>
                </div>
                <h3 className="text-sm font-semibold text-foreground-900 group-hover:text-primary-600 transition-colors line-clamp-1">{item.title}</h3>
                <p className="text-xs text-foreground-500 mt-1 line-clamp-2">{item.desc}</p>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}